import React, { useState, useLayoutEffect, useMemo } from 'react';
import { times } from 'lodash-es';

const useFillUpRow = (reportsCount, wrapperRef, { minWidthCard = 345, gap = 24 }) => {
  const [count, setCount] = useState(0);

  useLayoutEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) return undefined;

    const slotFullWidth = minWidthCard + gap;
    const compute = () => {
      const rowSize = Math.max(1, Math.floor((wrapper.offsetWidth + gap) / slotFullWidth));
      const remainder = reportsCount % rowSize;
      setCount(remainder && reportsCount > rowSize ? rowSize - remainder : 0);
    };

    compute();

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', compute);
      return () => window.removeEventListener('resize', compute);
    }

    const observer = new ResizeObserver(compute);
    observer.observe(wrapper);
    return () => observer.disconnect();
  }, [reportsCount, minWidthCard, gap, wrapperRef]);

  const cards = useMemo(
    () => (count > 0 ? times(count, (n) => <div key={n} className="fillup-row-item" />) : null),
    [count]
  );

  return cards;
};

export default useFillUpRow;
